module.exports = __webpack_public_path__ + "img/book2.d7eb9294.png";